export const MANUAL_TIME_ENTRY_KIND = {
  WORK: "work",
  ABSENCE: "absence",
} as const;

export type ManualTimeEntryKind =
  (typeof MANUAL_TIME_ENTRY_KIND)[keyof typeof MANUAL_TIME_ENTRY_KIND];
